import React, { useState } from 'react'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { ScrollArea } from '@/components/ui/scroll-area'

interface ConsentCheckboxProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}

const ConsentCheckbox = ({ checked, onCheckedChange }: ConsentCheckboxProps) => {
  const [aydinlatmaOpen, setAydinlatmaOpen] = useState(false)
  const [rizaOpen, setRizaOpen] = useState(false)

  const aydinlatmaText = `KİŞİSEL VERİLERİN KORUNMASI 

AYDINLATMA METNİ 

(Çalışan Bilgi Ölçme ve Değerlendirme Süreçlerine İlişkin) 

 

6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, Mavi Giyim San. ve Tic. A.Ş. ("Mavi"/ "Şirket") olarak veri sorumlusu sıfatıyla çalışan bilgi ölçme ve değerlendirme süreçlerine dahil olmanız halinde işlediğimiz kişisel verilerinize ilişkin aydınlatma yükümlülüğümüz kapsamında işbu metin ile bilgilendirilmeniz amaçlanmıştır. 

Kişisel Verileriniz, İşleme Amaçlarımız ve Hukuki Sebebimiz 

-       Mesleki bilgi ölçme sınavlarının yapılması ve yetkinliğinizin ölçülmesi amacıyla kimlik (ad, soyadı, sicil numarası) özlük (mağaza cari kodu, unvan, İşe başlangıç tarihi,  pozisyon/görevi, çalışacağı/çalıştığı mağaza, Sicil no, İşten çıkış tarihi, Bağlı olduğu yönetici, çalışma durumu, çalışan tipi, personel grubu, personel tipi, görev adı, Maviconnect sınav sonuçları, sınav katılım durumu, sınav tamamlanma tarihi/bitirme tarihi, eğitim memnuniyeti anket tamamlanma durumu ve sonuçları, anket bitirme tarihi, eğitimin atanma şekli, eğitim tamamlanma tarihi), iletişim (e-posta adresi), ), görsel ve işitsel kayıtlar  (görüntü, ses kaydı, fotoğraf) oluşan kişisel verilerinizi "ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla veri sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması" ve "Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli olması" hukuki sebeplerine  dayanarak işlemekteyiz. 

-       Uzaktan gerçekleştirdiğiniz işlemlerde kullandığınız cihazı tanımlayarak sizi diğer çalışanlardan ayırt edebilmek ve yaptığınız işlem ve verdiğiniz onayların kayıtlarının tutulması için işlem güvenliği (IP adres, log kaydı, kullanıcı şifresi bilginiz ve yaptığınız işlem ve verdiğiniz onayların log kayıtlarını), "ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla veri sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması" ve "veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması" hukuki sebeplerine dayanarak işlemekteyiz. 

-       Muhtemel mevzuata aykırı her türlü fiil, suç veya davranışa karşı sizin, Mavi'nin ve diğer üçüncü kişilerin güvenliğini sağlamak, mevzuattan kaynaklanan yükümlülüklerimizi yerine getirmek ve yetkili ve görevli özel veya kamu kurum ve kuruluşlarına karşı hukuki yükümlüklerimizi yerine getirmek, doğacak uyuşmazlıklarda mahkeme, icra dairesi, hakem heyeti gibi resmi kurum ve kuruluşlara karşı her türlü dava, cevap ve itiraz hakkının kullanılması, uyuşmazlıklara ilişkin görüşme ve anlaşma süreçlerinin yürütülmesi, tarafımızdan bilgi talep etmeniz veya yasal haklarınız kapsamında başvuruda bulunmanız halinde gerekli bilgilerin tarafınıza ulaştırılabilmesi, operasyonel süreçlere ilişkin stratejik planlama, analiz ve iş geliştirme çalışmaları yapılması amacıyla yukarıda sayılan kişisel verileriniz ve hukuki işlem verilerinizi "bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması" ve "veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması" hukuki sebeplerine dayanarak işlemekteyiz. 

Kişisel Verilerinizi Toplama Yöntemimiz 

Kişisel verileriniz çevrimiçi sınav platformu üzerinden otomatik olan yollarla Kanun'a uygun şekilde elde edilmektedir. 

Kişisel Verilerinizin Aktarılması 

Mavi olarak kişisel verilerinizi ancak işbu Metin'de belirtilen amaçlar doğrultusunda ve KVKK'nın 8. ve 9. maddelerine uygun olarak üçüncü kişilere aktarmaktayız. Bu kapsamda; 

-       Bilgi ölçme ve değerlendirme süreçlerine yönelik test ve sınavların yapılmasının sağlanması ile Şirket'in insan kaynakları süreçleri ile ilgili destek hizmetlerin alınabilmesi amacıyla yurt içinde bulunan iş ortakları, tedarikçi ve hizmet sağlayıcılarıyla (çevrim içi sınav platformu, veri tabanı ve sunucu hizmeti sağlayıcıları, altyapı bakım ve destek ve yazılım lisanslama hizmeti sağlayıcıları, hukuki danışmanlık hizmeti verenler gibi) ile bu firmalar tarafından Mavi'nin faaliyetlerinin yerine getirilmesi amacı ile verilen hizmetler dâhilinde kullanılması kaydıyla aktarmaktayız. 

-       Yetkili ve görevli özel veya kamu kurum ve kuruluşlar ile adli makamlara ve resmi kurum/kuruluşlara karşı olan bilgi, belge verme ve ilgili sair yükümlülüklerimizi yerine getirmek, dava ve cevap hakları gibi yasal haklarımızı kullanabilmek ile başkaca yasal hak ve yükümlülüklerimizi yerine getirebilmek amacıyla mahkemeler, icra müdürlükleri, kolluk kuvvetleri, bakanlıklar başta olmak üzere yetkili kamu kurum ve kuruluşlarına aktarabilmekteyiz. 

Yurt dışı aktarımı: Ayrıca açık rıza metni ile rıza vermeniz halinde, bilişim teknolojileri, uzmanlık gerektiren danışmanlık vb. konularda ürün ve hizmet desteği almak amaçlarıyla yurt dışında bulunan hizmet sağlayıcıları ve iş ortaklarıyla (yazılım geliştirme ve destek hizmeti, hosting, bakım, altyapı bakım ve geliştirme bakım hizmeti sağlayıcıları, veri tabanı ve sunucu hizmeti sağlayıcıları, gibi) ve bu suretle yurt içindeki ve/veya yurt dışındaki ilgili tedarikçilerin sunucularının yurt dışında olması sebebiyle kimlik, iletişim, işlem güvenliği, görsel ve işitsel, özlük verilerinizi KVKK'nın 9. maddesinde yer alan şartlara uygun olarak yurt dışına aktarmaktayız. 

KVKK Kapsamındaki Haklarınız 

Mavi tarafından işlenen kişisel verilerinize ilişkin olarak KVKK'nın 11. maddesi kapsamındaki taleplerinizi; Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ'e uygun şekilde yazılı olarak ya da kayıtlı elektronik posta (KEP) adresi, güvenli elektronik imza, mobil imza ya da Mavi'ye daha önce bildirdiğiniz ve sistemimizde kayıtlı bulunan elektronik posta adresinizi kullanarak aşağıdaki adreslere her zaman iletebilirsiniz.  

Veri Sorumlusu: Mavi Giyim San. ve Tic. A.Ş. 

E-posta: kisiselveriler@mavi.com 

Kep Adresi: mavigiyim.hukuk@hs03.kep.tr 

Adres: Sultan Selim Mah. Eski Büyükdere Cad. No:53/2 34418 Kağıthane/İSTANBUL`

  const rizaText = `Kişisel Verilerin Yurtdışına Aktarılmasına Dair Açık Rıza Beyanı 

(Çalışan Bilgi Ölçme ve Değerlendirme Süreçlerine İlişkin) 

 

Kişisel verilerimin, "Çalışan Bilgi Ölçme ve Değerlendirme Süreçlerine İlişkin Kişisel Verilerin Korunması Aydınlatma Metni'nde detaylı olarak açıklandığı şekilde ve aşağıda onay verdiğim süreç/süreçlere ilişkin olarak, Mavi Giyim San. ve Tic. A.Ş. ("Mavi") ve veri işleyenleri tarafından yurt dışına aktarılmasına onay veriyorum.  

 

 

Yurt Dışına Aktarım: Bilişim teknolojileri ya da uzmanlık gerektiren danışmanlık vb. konularda ürün ve hizmet desteği almak amacıyla Mavi'nin yurt dışında bulunan hizmet sağlayıcıları ve iş ortaklarıyla (yazılım geliştirme ve destek hizmeti, hosting, bakım ve geliştirme bakım hizmeti) ve/veya yurt içindeki/yurt dışındaki tedarikçilerinin sunucularının yurt dışında olması sebebi ile kişisel verilerimin yurt dışı ile paylaşılmasına onay veriyorum.`

  return (
    <div className="space-y-3">
      <div className="flex items-start space-x-3">
        <Checkbox
          id="consent"
          checked={checked}
          onCheckedChange={(checked) => onCheckedChange(checked === true)}
        />
        <Label htmlFor="consent" className="text-sm leading-relaxed cursor-pointer">
          Kişisel verilerimin işlenmesine ilişkin{' '}
          <Dialog open={aydinlatmaOpen} onOpenChange={setAydinlatmaOpen}>
            <DialogTrigger asChild>
              <button
                type="button"
                className="text-blue-600 hover:text-blue-800 underline"
                onClick={(e) => {
                  e.preventDefault()
                  setAydinlatmaOpen(true)
                }}
              >
                aydınlatma metnini
              </button>
            </DialogTrigger>
            <DialogContent className="max-w-4xl max-h-[80vh]">
              <DialogHeader>
                <DialogTitle>Kişisel Verilerin Korunması Aydınlatma Metni</DialogTitle>
              </DialogHeader>
              <ScrollArea className="h-[60vh] pr-4">
                <div className="whitespace-pre-line text-sm">{aydinlatmaText}</div>
              </ScrollArea>
            </DialogContent>
          </Dialog>{' '}
          ve{' '}
          <Dialog open={rizaOpen} onOpenChange={setRizaOpen}>
            <DialogTrigger asChild>
              <button
                type="button"
                className="text-blue-600 hover:text-blue-800 underline"
                onClick={(e) => {
                  e.preventDefault()
                  setRizaOpen(true)
                }}
              >
                açık rıza beyanını
              </button>
            </DialogTrigger>
            <DialogContent className="max-w-4xl max-h-[80vh]">
              <DialogHeader>
                <DialogTitle>Açık Rıza Beyanı</DialogTitle>
              </DialogHeader>
              <ScrollArea className="h-[60vh] pr-4">
                <div className="whitespace-pre-line text-sm">{rizaText}</div>
              </ScrollArea>
            </DialogContent>
          </Dialog>{' '}
          okudum ve onaylıyorum
        </Label>
      </div>
    </div>
  )
}

export default ConsentCheckbox
